'use client';

import { Badge } from '@/components/ui/badge';
import type { SourceRunStatus } from '@/lib/sources/source-types';

export function StatusBadge({ status }: { status: SourceRunStatus['status'] }) {
  switch (status) {
    case 'ok':
      return <Badge variant="secondary">OK</Badge>;
    case 'warning':
      return (
        <Badge variant="outline" className="border-yellow-500/50 text-yellow-600">
          Warning
        </Badge>
      );
    case 'error':
      return <Badge variant="destructive">Failed</Badge>;
  }
}
